<template>
    <div class="gcmcn-card taker-configuration">
        <div class="taker-configuration-container">
            <div class="taker-information">
                <img :src="taker.logo">
                <div>
                    {{ taker.name}}
                </div>
            </div>
            <div>
                <configuration-button
                    v-if="feedResource.status !== 'FINISHED'"
                    :stream="feedResource"
                    :feed="feedResource"
                    :stream-type="'feedResource'"
                    :configuration="takerConfigurationRelatedToFeed"
                    @create-configuration="onCreateconfiguration"
                    @on-configuration-cancelled="$emit('on-configuration-cancelled')"
                ></configuration-button>
            </div>
        </div>
        <configuration-detail
            :configuration="lastConfiguration"
            :configurations-count="filteredConfigurations.length"
            :stream-type="'feedResource'"
            :dashboard-card="true"
            @trigger-refresh="triggerRefresh()"
        ></configuration-detail>
    </div>
</template>

<script>
import ConfigurationButton from 'gcmcn-common/src/components/configurationButton/index.vue';
import { ConfigurationDetail } from 'gcmcn-common';
export default {

    components: {
        ConfigurationButton,
        ConfigurationDetail
    },

    props: {
        taker: {
            type: Object,
            required: true,
        },
        configurations: {
            type: Array,
            required: true,
        },
        feedResource: {
            required: true,
            type: Object,
        },
    },

    data (){
        return {

        };
    },

    computed: {
        lastConfiguration(){
            if(this.filteredConfigurations.length > 0){
                return this.filteredConfigurations[0];
            }
            return {};
        },
        filteredConfigurations() {
            return this.configurations.filter(configuration => {
                return configuration.feed_resource_uid === this.feedResource.uid && configuration.taker_uid === this.taker.uid && !['FAILED', 'ABORTED'].includes(configuration.status);
            }).sort((a,b) => {
                return new Date(b.creation_date) - new Date(a.creation_date);
            });
        },
        takerConfigurationRelatedToFeed (){
            return this.configurations.find((conf) => {
                // TODO : Handle FAILED in configuration-button
                return conf.taker_uid === this.taker.uid &&
                       !['FINISHED', 'FAILED_TO_CONNECT', 'ABORTED'].includes(conf.status);
            }) || null;
        },
    },

    mounted (){

    },

    methods: {
        onCreateconfiguration (){
            this.$emit('on-load-taker-group', true);
            this.$store.dispatch('remoteGet', {
                url: `group/${this.taker.group_uid}`
            })
            .then((res) => {
                this.$emit('on-load-taker-group', false);
                this.$emit('create-configuration', this.taker, res.data);
            }).finally(() => {
                this.$emit('on-load-taker-group', false);
            });
        },
        triggerRefresh(){
            this.$emit('trigger-refresh');
        }
    },
};
</script>

<style lang="scss">
.taker-configuration{
    height: auto;
    min-height: 130px;
    & + .taker-configuration{
        margin-top: 10px;
    }
    .taker-configuration-container{
        display: flex;
        justify-content: space-between;
        align-items: center;

        .taker-information{
            flex-basis: 60%;
            display: flex;
            align-items: center;

            img{
                width: 35%;
                max-width: 100px;
                margin-right: 15px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/FeedResources/feedResourceDetails/taker-configuration.vue